/* import __COLOCATED_TEMPLATE__ from './alert-circle.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();